import React from 'react';
import { Search, Palette, Rocket, RefreshCw } from 'lucide-react';
import { processSteps } from '../data/mock';

const iconMap = {
  Search,
  Palette,
  Rocket,
  RefreshCw
};

const Process = () => {
  return (
    <section className="process-section">
      <div className="section-container">
        <div className="section-header-center">
          <h2 className="section-title-large">Cómo Trabajamos</h2>
          <p className="section-subtitle">
            Un proceso simple y transparente de principio a fin
          </p>
        </div>

        <div className="process-timeline">
          {processSteps.map((step, index) => {
            const IconComponent = iconMap[step.icon];
            return (
              <div key={step.id} className="process-step">
                <div className="process-step-number">{step.id}</div>
                <div className="process-step-content">
                  <div className="process-icon-wrapper">
                    <IconComponent className="process-icon" size={36} />
                  </div>
                  <h3 className="process-title">{step.title}</h3>
                  <p className="process-description">{step.description}</p>
                </div>
                {index < processSteps.length - 1 && (
                  <div className="process-connector"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Process;
